import { useTranslation } from "react-i18next";
import { Box, Menu, MenuItem } from "@mui/material";
import { useStyles } from "./editor-menu.style";
import DeleteIcon from "@iconify/icons-mdi/delete";
import PencilIcon from "@iconify/icons-mdi/pencil";
import { InlineIcon } from "@iconify/react";

interface OcEditorMenuProps {
  handleClose: () => void;
  handleModified: () => void;
  handleDelete: () => void;
  anchorEl: null | HTMLElement;
}

export const OcEditorMenu = ({
  handleClose,
  handleModified,
  handleDelete,
  anchorEl,
}: OcEditorMenuProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
      elevation={0}
      anchorOrigin={{
        vertical: 30,
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      style={{
        borderRadius: "4px",
      }}
    >
      <Box>
        <MenuItem id="modified-application" onClick={handleModified}>
          <InlineIcon icon={PencilIcon} className={classes.icon} />
          <span className={classes.text}>{t("OC_MODIFY")}</span>
        </MenuItem>
        <MenuItem id="delete-application" onClick={handleDelete}>
          <InlineIcon icon={DeleteIcon} className={classes.icon} />
          <span className={classes.text}>{t("OC_DELETE")}</span>
        </MenuItem>
      </Box>
    </Menu>
  );
};

export default OcEditorMenu;
